import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as constants from './social_template_constants';
import shopMyLogoWhite from '../../../../static/images/logos/shop_my_white.png';
import './SocialSharingPinSquare.scss';

import SocialSharingTemplateControls from './SocialSharingTemplateControls';
import { filterAndSortPinsForSocialSharing } from '../../../../Helpers/social_sharing_template_helpers';

const SocialSharingPinSquare = props => {
  const { elementId, collection } = props;
  const { ASPECT_RATIO } = constants;
  const { pins, name } = collection;

  const [backgroundColor, setBackgroundColor] = useState('#171919');
  const [textColor, setTextColor] = useState('#ffffff');
  const [logoColor, setLogoColor] = useState('#ffffff');
  const logoBrightness = logoColor === '#ffffff' ? 1 : 0;
  const logoHidden = logoColor === 'transparent';

  const topPins = filterAndSortPinsForSocialSharing(pins).slice(0, 6);
  if (!topPins.length) return null;
  return (
    <div className='social-sharing-template'>
      <div className='downloadable-content-container social-sharing-pin-square-outer-container'>
        <div className='downloadable-content' id={elementId} style={{ aspectRatio: ASPECT_RATIO, background: backgroundColor, color: textColor }}>
          <div className='downloadable-content-inner'>
            <div className='pin-image-grid'>
              {topPins.map((pin, idx) => {
                const { image, title } = pin;
                return (
                  <div className='pin-image-container' key={idx}>
                    <img className='pin-image' alt={title} src={image} />
                  </div>
                );
              })}
            </div>
            <div className='title-container'>
              <div className='big-title'>{name}</div>
              <div className='medium-subtitle'>
                {pins.length} Item{pins.length === 1 ? '' : 's'}
              </div>
            </div>
            {!logoHidden && (
              <img style={{ filter: `brightness(${logoBrightness})` }} height={15} className='logo' src={shopMyLogoWhite} alt='shopmy_logo' />
            )}
          </div>
        </div>
      </div>
      <SocialSharingTemplateControls
        collection={collection}
        elementId={elementId}
        backgroundColor={backgroundColor}
        setBackgroundColor={setBackgroundColor}
        textColor={textColor}
        setTextColor={setTextColor}
        logoColor={logoColor}
        setLogoColor={setLogoColor}
      />
    </div>
  );
};

SocialSharingPinSquare.propTypes = {
  elementId: PropTypes.string.isRequired,
  collection: PropTypes.object.isRequired
};

export default SocialSharingPinSquare;
